import { render } from "./StudentPlaceQcm.vue?vue&type=template&id=b38c06ba&scoped=true"
import script from "./StudentPlaceQcm.vue?vue&type=script&lang=js"
export * from "./StudentPlaceQcm.vue?vue&type=script&lang=js"

import "./StudentPlaceQcm.vue?vue&type=style&index=0&id=b38c06ba&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b38c06ba"]])

export default __exports__